<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div v-show="is_loading">
          <skeleton-box
            height="30px"
            width="100%"/>
        </div>
        <div v-show="!is_loading">
          <p class="m-0 font-weight-bold">{{ invoice.status }}</p>
        </div>
      </div>
      <div class="col-12">
        <user-info
          :is_loading="is_loading"
          :data="invoice"/>
        <order-info
          :is_loading="is_loading"
          :data="invoice"/>
        <payment-info
          :is_loading="is_loading"
          :data="invoice"/>
        <helper-info
          v-if="invoice.helper != null"
          :is_loading="is_loading"
          :data="invoice"/>
        <div class="row">
          <div class="col-6">
            <rating-majikan
              :is_loading="is_loading"
              :data="invoice"
              host="/order-call"
              v-if="invoice.rating_majikan != null"/>
          </div>
          <div class="col-6">
            <rating-helper
              :is_loading="is_loading"
              :data="invoice"
              host="/order-call"
              v-if="invoice.rating_helper != null"/>
          </div>
        </div>
        <detail
          :is_loading="is_loading"
          :data="invoice"/>
      </div>
    </div>
    <div class="row" v-show="!is_loading">
      <div class="col-12 text-right">
        <a :href="'/order-call/choose?id='+invoice.id" 
          v-if="(invoice.status != 'Selesai' && invoice.status != 'Batal') && invoice.xendit_status === 'PAID'" 
          class="btn btn-success ml-3">Choose Helper</a>
        <span v-if="invoice.helper != null && invoice.status == 'Selesai'">
          <button @click="rating_action('majikan')" 
            :disabled="invoice.rating_majikan != null" 
            class="btn btn-primary ml-3">Bypass Rating Majikan</button>
          <button @click="rating_action('helper')" 
            :disabled="invoice.rating_helper != null" 
            class="btn btn-primary ml-3">Bypass Rating Helper</button>
        </span>
        <a href="#!" class="btn btn-primary ml-3">Print</a>
        <a href="#!" @click="download" class="btn btn-primary ml-3">Download</a>
        <button class="btn btn-primary ml-3" v-if="invoice.xendit_status == 'PENDING'" v-on:click="bypass_payment">Bypass Payment</button>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBox from '@/layout/skeleton'
import CallDetail from '@/pages/order_call/component/table_detail'
import UserInfo from '@/pages/order_call/component/user_info'
import OrderInfo from '@/pages/order_call/component/order_info'
import PaymentInfo from '@/pages/order_call/component/payment_info'
import HelperInfo from '@/pages/order_call/component/helper_info'
import RatingMajikan from '@/pages/order_call/component/rating_majikan'
import RatingHelper from '@/pages/order_call/component/rating_helper'

export default{
  components:{
    'skeleton-box': SkeletonBox,
    'detail': CallDetail,
    'user-info': UserInfo,
    'order-info': OrderInfo,
    'payment-info': PaymentInfo,
    'helper-info': HelperInfo,
    'rating-majikan': RatingMajikan,
    'rating-helper': RatingHelper,
  },
  data(){
    return{
      invoice: {
        id: '',
        date: moment(),
        admin_fee: 0,
        total_price: 0,
        grand_total: 0,
        discount: 0,
        status: '',
        address: '',
        notes: '',
        scheduled_at: moment(),
        end_at: moment(),
        payment_method: {
          name: ''
        },
        user: {
          id: ""
        },
        helper: {
          id: ""
        },
        detail: [],
        rating_helper: null,
        rating_majikan: null,
      },
      user: {
        name: 'test',
        email: 'test@test.com',
        phone_number: '121221',
      },
      is_loading: true,
      type: '',
      arr_detail: [],
      setting: {
        name: '',
        company_name: '',
      },
    }
  },
  async created(){
    await this.get_data()
    await this.get_setting()
    this.is_loading = false
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/order-call?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.invoice = response_data.data
          this.invoice.date = moment(response_data.data.created_at)
          this.invoice.scheduled_at = moment(response_data.data.scheduled_at)
          this.invoice.end_at = moment(response_data.data.end_at)
          if(this.invoice.status == 'wait')
            this.invoice.status = 'Request Rekrut'
          else if(this.invoice.status == 'on_going')
            this.invoice.status = 'Sedang Berjalan'
          else if(this.invoice.status == 'done')
            this.invoice.status = 'Selesai'
          else if(this.invoice.status == 'cancel')
            this.invoice.status = 'Batal'
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async get_setting(){
      try{
        var response = await axios.get(base_url+'/setting')

        var response_data = response.data
        if(response_data.status == "success"){
          this.setting = response_data.data
          // console.log(moment(response_data.data.publish_date).format('DD/MM/YYYY'))
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async bypass_payment(){
      try{
        var data = {}
        data.id = this.invoice.id

        var response = await axios.put(base_url+'/order/payment',data)

        var response_data = response.data
        if(response_data.status == "success"){
          this.is_loading = true
          await this.get_data()
          this.is_loading = false
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    download(){
      location.href = base_url+'/order/download?id='+this.$route.query.id
    },
    rating_action(type){
      if(type == "majikan")
        location.href = '/order-call/rating?invoice_call_id='+this.invoice.id+'&user_id='+this.invoice.user.id+'&recipient_id='+this.invoice.helper.id
      else
        location.href = '/order-call/rating?invoice_call_id='+this.invoice.id+'&user_id='+this.invoice.helper.id+'&recipient_id='+this.invoice.user.id
    }
  }
}
</script>
